import React from 'react';
import { Grid } from '@mui/material';
import LogoInter from '../../assets/img/footer/LogoInter-w.svg';
import LogoApple from '../../assets/img/footer/Apple-gray.svg';
import LogoGoogle from '../../assets/img/footer/Google-gray.svg';
import LFace from '../../assets/img/footer/LFacebook.svg';
import LInst from '../../assets/img/footer/LInstagram.svg';
import LIn from '../../assets/img/footer/LLinkedIn.svg';
import LTik from '../../assets/img/footer/LTikTok.svg';
import LYou from '../../assets/img/footer/LYoutube.svg';
import Container from '@mui/material/Container';

export default function Footer(props) {
  return (
    <div className="footer">
      <Container maxWidth="lg">
        <Grid container >
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <img src={LogoInter} alt='LogoInter' />
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div className='header-footer' style={{ padding: '20px' }} >Productos</div>
            <div style={{ paddingLeft: '20px' }}>
              <a className='a' href='https://cocheseguro.inter.mx/inicio' target='_blank' rel="noreferrer" >
                <div className='body-footer' >Coche Seguro</div>
              </a>
              <div style={{ paddingTop: '5px' }}>
                <a className='a' href='https://productos.inter.mx/gastos-medicos-mayores/' target='_blank' rel="noreferrer"  >
                  <div className='body-footer' >M&eacute;dico Seguro</div>
                </a>
              </div>
              <div style={{ paddingTop: '5px' }}>
                <a className='a' href='https://productos.inter.mx/vida-segura' target='_blank' rel="noreferrer"  >
                  <div className='body-footer' >Vida Seguro</div>
                </a>
              </div>
              <div style={{ paddingTop: '5px' }}>
                <a className='a' href='https://mascotasegura.inter.mx/seguro-mascota/landing' target='_blank' rel="noreferrer"  >
                  <div className='body-footer' >Mascota Segura</div>
                </a>
              </div>
              <div style={{ paddingTop: '5px' }}>
                <a className='a' href='https://inter.mx/viaje-seguro' target='_blank' rel="noreferrer"  >
                  <div className='body-footer' >Viaje Seguro</div>
                </a>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div style={{ padding: '20px' }} >
              <div className='header-footer' >Cont&aacute;ctanos</div>
              <div style={{ paddingTop: '20px' }}>
                <div className='body-footer pt-5' >55 442 46837</div>
                <div style={{ paddingTop: '5px' }}>
                  <a className='a' href='mailto:hola@inter.mx' target='_blank' rel="noreferrer" >
                    <div className='body-footer'>hola@inter.mx</div>
                  </a>
                </div>
              </div>
              <div style={{ paddingTop: '30px' }}>
                <div className='header-footer' >Clientes</div>
                <div style={{ paddingTop: '20px' }}>
                  <a className='a' href='mailto:hola@inter.mx' target='_blank' rel="noreferrer" >
                    <div className='body-footer'>Login clientes corporativos</div>
                  </a>
                </div>
                <div style={{ paddingTop: '5px' }}>
                  <a className='a' href='mailto:hola@inter.mx' target='_blank' rel="noreferrer" >
                    <div className='body-footer'>Av&iacute;so de privacidad</div>
                  </a>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
            <div style={{ padding: '20px' }} >
              <div className='header-footer' >Descarga nuestra app</div>
              <div className='logos flex flex-wrap' >
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingRight: '20px' }} >
                    <a href='https://apps.apple.com/mx/app/intermx/id1548367767?l=en' target='_blank' rel="noreferrer" >
                      <img src={LogoApple} alt='LogoApple' />
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: '20px' }}>
                  <a href='https://play.google.com/store/apps/details?id=grut.inter.mx' target='_blank' rel="noreferrer" >
                    <img src={LogoGoogle} alt='LogoGoogle' />
                  </a>
                </div>
              </div>
            </div>
            <div style={{ padding: '10px' }}>
              <div className='header-footer' >Siguenos en redes sociales</div>
              <div className='logos-footer pt-3'>
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingRight: '20px' }}>
                    <a href='https://www.facebook.com/intermx' target='_blank' rel="noreferrer" >
                      <img src={LFace} alt='LFace' />
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingRight: '20px' }}>
                    <a href='https://www.instagram.com/interproteccion/' target='_blank' rel="noreferrer"  >
                      <img src={LInst} alt='LInst' />
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingRight: '20px' }}>
                    <a href='https://www.linkedin.com/company/interproteccion/' target='_blank' rel="noreferrer"  >
                      <img src={LIn} alt='LIn' />
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: '20px' }}>
                  <div style={{ paddingRight: '20px' }}>
                    <a href='https://vm.tiktok.com/ZMeSRnwDw/' target='_blank' rel="noreferrer"  >
                      <img src={LTik} alt='LTik' />
                    </a>
                  </div>
                </div>
                <div style={{ paddingTop: '20px' }}>
                  <a href='https://www.youtube.com/channel/UCZ8wH2JLzDYvvrN-JiG3roA' target='_blank' rel="noreferrer" >
                    <img src={LYou} alt='LYou' />
                  </a>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container columns={1} alignItems="center" >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className='footer-footer pb-1rem' style={{ textAlign: "center" }}>Copyright {new Date().getFullYear()}® Interprotecci&oacute;n</div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}